class CampaignBanner {
  constructor() {
    this.init()
  }

  init() {
    const _this = this

    // If banner element doesn't exist or is hidden, return
    const $banner = document.querySelector('.campaign-banner')
    if (!$banner || _this.getIsHidden()) return

    // Otherwise show the banner and add an event listener to
    // the close button
    $banner.classList.add('show')

    const $close = $banner.querySelector('.close')
    $close.addEventListener('click', function () {
      $banner.classList.remove('show')
      _this.setIsHidden(true)
    })
  }

  getIsHidden() {
    return window.localStorage.getItem('CAMPAIGN_BANNER_HIDDEN')
  }

  setIsHidden(val) {
    return window.localStorage.setItem('CAMPAIGN_BANNER_HIDDEN', val)
  }
}

export default CampaignBanner
